{
  "nummer": 8,
  "sha256": "9a9b0f444ba7ddd3ad360480646f9d268642a12542efe84fdfd2db4ccb4aba88"
}
